export default __webpack_public_path__ + "static/media/ai4.988b99a3.png";